import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3","key":"svg-0"}],["path",{"d":"M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3","key":"svg-1"}]]

/**
 * IconZodiacAquarius
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItem9kaWFjLWFxdWFyaXVzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDEwbDMgLTNsMyAzbDMgLTNsMyAzbDMgLTNsMyAzIiAvPgogIDxwYXRoIGQ9Ik0zIDE3bDMgLTNsMyAzbDMgLTNsMyAzbDMgLTNsMyAzIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/zodiac-aquarius
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZodiacAquarius = createReactComponent('outline', 'zodiac-aquarius', 'ZodiacAquarius', __iconNode);

export default IconZodiacAquarius;